// extracted by mini-css-extract-plugin
export var bounce = "_pd-1";
export var generatingText = "_pd-6";
export var lightning = "_pd-4";
export var popup = "_pd-5";
export var progressBar = "_pd-7";
export var progressFill = "_pd-8";
export var progressShimmer = "_pd-9";
export var progressText = "_pd-a";
export var shimmer = "_pd-3";
export var uploadIcon = "_pd-0";
export var uploadingText = "_pd-2";